/**
 * Centralized local image URLs for the entire site.
 * Files live in client/public/manus-storage.
 * Naming: projekt{N} = customer project photo N from Google Drive
 */

export const IMAGES = {
  // AI-generated hero images (optimized versions)
  heroUterum: "/manus-storage/hero-uterum-optimized_1ba22ac8.webp",
  heroUterumMobile: "/manus-storage/hero-uterum-mobile_bafa3773.webp",
  heroUterumFull: "/manus-storage/hero-uterum-XF8RoHK5vqezQxX2oRfFMg.webp",
  heroInspiration: "/manus-storage/hero-inspiration-83oy3J7oY6GzGUSSQxWoUt.webp",
  heroVinterbonat: "/manus-storage/hero-vinterbonat-8FNEDAJE3kPPmj7ohbnzbg.webp",
  heroBygglov: "/manus-storage/hero-bygglov-5xKhaSsbLnKjXj2uyMLASt.webp",
  heroGlaspartier: "/manus-storage/hero-glaspartier-243n9rxehZLm5WeRiUvscT.webp",

  // AI-generated visualizations (3D renders)
  ai15m2_1: "/manus-storage/ai-15m2-1_13bb99b9.webp",
  ai15m2_2: "/manus-storage/ai-15m2-2_ac61fcb6.png",
  ai20m2_1: "/manus-storage/ai-20m2-1_008a3a83.webp",
  ai20m2_2: "/manus-storage/ai-20m2-2_19882623.png",
  aiExtra1: "/manus-storage/ai-extra-1_3f357b3e.png",

  // Case media: 3D rendering + customer videos
  case3dRottHus: "/manus-storage/opt-uterum-3d-rendering-rott-hus_d4636046_61c5179f.webp",
  case3dRottHusFull: "/manus-storage/uterum-3d-rendering-rott-hus_d4636046.webp",
  videoAllaArstider: "/manus-storage/hero-video-optimized_f1debcf9.mp4",
  videoForlangerSommaren: "/manus-storage/video2-optimized_0a7a53ce.mp4",

  // AI illustrations (house + conservatory)
  aiIllustration1a: "/manus-storage/ai-illustration-1a_0683282a.png",
  aiIllustration1b: "/manus-storage/ai-illustration-1b_2eee38ae.png",
  aiIllustration1c: "/manus-storage/ai-illustration-1c_02a59976.png",
  aiIllustration1d: "/manus-storage/ai-illustration-1d_8be31c5a.png",

  // Customer project photos (from Google Drive)
  projekt7_2: "/manus-storage/7-2_87ce632e.jpg",
  projekt8: "/manus-storage/uterum-projekt-8_ce7399b0.jpg",
  projekt9: "/manus-storage/uterum-projekt-9_c1839a84.jpg",
  projekt9_1: "/manus-storage/9-1_779b29eb.jpg",
  projekt10: "/manus-storage/uterum-projekt-10_06135a69.jpg",
  projekt10_2: "/manus-storage/10-2_8804ac78.jpg",
  projekt12: "/manus-storage/uterum-projekt-12_4e3ccabe.jpg",
  projekt12_1: "/manus-storage/12-1_27ed54f6.jpg",
  projekt13: "/manus-storage/uterum-projekt-13_aef0236b.jpg",
  projekt13_1: "/manus-storage/uterum-projekt-13-1_6c245a59.jpg",
  projekt14: "/manus-storage/14_6a08bdaa.jpg",
  projekt14_1: "/manus-storage/14-1_18dd0a59.jpg",
  projekt17: "/manus-storage/17-optimized_b2e6548c.webp",
  projekt17Full: "/manus-storage/17_e0a2093b.jpg",
  projekt17_1: "/manus-storage/17-1_ffa7aba4.jpg",
  projekt18: "/manus-storage/18_0cb1f4a2.jpg",
  projekt20: "/manus-storage/20_2e8053a1.jpg",
  projekt20_1: "/manus-storage/20-1_1fd0c087.jpg",
  projekt24_1: "/manus-storage/24-1_8a3aae30.jpg",
  projekt25_1: "/manus-storage/25-1_327d0d30.jpg",
  projekt27_1: "/manus-storage/27-1_c73c4c94-opt_8577374c.webp",
  projekt27_1Full: "/manus-storage/27-1_c73c4c94.jpg",
  projekt30: "/manus-storage/30_36f75238.jpg",
  projekt30_1: "/manus-storage/30-1_1c708597.jpg",
  projekt31_1: "/manus-storage/31-1_75c56aea.jpg",
  projekt33: "/manus-storage/33_392b3527.jpg",
  projekt33_1: "/manus-storage/33-1_61571c86.jpg",
  projekt40: "/manus-storage/40_aff5c7ed.jpg",
  projekt40_1: "/manus-storage/40-1_8f48a895.jpg",
  projekt41: "/manus-storage/41_c2d8de9a-opt_fc94dad0.webp",
  projekt41Full: "/manus-storage/41_c2d8de9a.jpg",
  projekt46: "/manus-storage/46_e118a3a0-opt_4e16a78f.webp",
  projekt46Full: "/manus-storage/46_e118a3a0.jpg",
  projekt56_1: "/manus-storage/56-1_17a42645.jpg",
  // === OneDrive content: Visualiseringar & Renderingar ===
  houseDroneView: "/manus-storage/house-drone-view-v2_4f308b2f-opt_6b155988.webp",
  houseDroneViewFull: "/manus-storage/house-drone-view-v2_4f308b2f.webp",
  houseDroneRailing: "/manus-storage/house-drone-railing-to-wall_04a1e4a7.webp",
  houseArmchairs: "/manus-storage/opt-house-armchairs_44f1befd_a2640d9e.webp",
  houseArmchairsFull: "/manus-storage/house-armchairs_44f1befd.webp",
  houseCozyCashmere: "/manus-storage/house-cozy-cashmere_0fa8168a.webp",
  houseViewCloseup: "/manus-storage/house-view-closeup_b06df17b.webp",
  houseViewTopdown: "/manus-storage/house-view-topdown_117c7f6c.webp",
  houseWithModule: "/manus-storage/house-with-module-v3_764fe3f3.webp",
  poolVisualization: "/manus-storage/pool-visualization-roof-ext2_0be68e09.webp",
  uterumDagtid: "/manus-storage/uterum-dagtid_e631d7f3.webp",
  uterumNightFurnished: "/manus-storage/uterum-night-furnished_05f8ade2.webp",
  uterumDayFurnished: "/manus-storage/uterum-day-furnished_280208c0.webp",
  uterumFatoljerMatbord: "/manus-storage/uterum-fatoljer-matbord_7b998b58.webp",
  uterumVisualisering: "/manus-storage/uterum-visualisering-v4_9dc9cb4d.webp",
  cornerEvening: "/manus-storage/opt-corner-evening_50a2c96f_e37b3a3c.webp",
  cornerEveningFull: "/manus-storage/corner-evening_50a2c96f.webp",
  cornerDaytime: "/manus-storage/corner-daytime_aca73280.webp",
  dronbildMoblerad: "/manus-storage/dronarbild-moblerad_c41aa033.webp",
  uterumRodTra: "/manus-storage/uterum-rod-tra_b405961a.webp",
  bakifranTrapp: "/manus-storage/v2-bild5-bakifran-snett-trappa_e699c8d4.webp",
  vyUtanSno: "/manus-storage/vy6-utan-sno-v2_aaa28d78.webp",
  nyttUterum1: "/manus-storage/nytt-u-1_85e0d26f.webp",
  nyttUterum2: "/manus-storage/nytt-u-2_2350086e.webp",
  rendering2: "/manus-storage/2_ab139642.webp",
  image5: "/manus-storage/image-5_7b4e76b5.webp",

  // === OneDrive content: Pulpettak-serien ===
  pulpet1: "/manus-storage/pulpet-1_a6a327a5.webp",
  pulpet2: "/manus-storage/pulpet-2_bd9b2d57.webp",
  pulpet3: "/manus-storage/pulpet-3_dffceecc.webp",
  pulpet4: "/manus-storage/pulpet-4_d947015a.webp",
  pulpet5: "/manus-storage/pulpet-5_e2b45bc4.webp",
  pulpet6: "/manus-storage/pulpet-6_89541df9.webp",
  pulpet7: "/manus-storage/pulpet-7_55fc9fa1.webp",
  pulpet8: "/manus-storage/pulpet-8_4d6d6425.webp",
  pulpet9: "/manus-storage/pulpet-9_b9942c15.webp",
  pulpet10: "/manus-storage/pulpet-10_4cf47436.webp",

  // === OneDrive content: Villa-serien ===
  villa1: "/manus-storage/villa-1_75bfa5fd.webp",
  villa2: "/manus-storage/villa-2_502cfaad.webp",
  villa3: "/manus-storage/villa-3_20794070.webp",
  villa4: "/manus-storage/villa-4_a2138098.webp",
  villa5: "/manus-storage/villa-5_72a7843e.webp",

  // === OneDrive content: Inglasningar ===
  inglasning1: "/manus-storage/inglasning-1_cdb87305.webp",
  inglasning2: "/manus-storage/inglasning-2_18416b3d.webp",
  inglasning3: "/manus-storage/inglasning-3_528730fd.webp",
  inglasning4: "/manus-storage/inglasning-4_c26662d0.webp",

  // === OneDrive content: Skjutglas ===
  skjutglas24: "/manus-storage/24-uterum-skjutglas_ff1c1cac.webp",
  skjutglas25: "/manus-storage/25-uterum-skjutglas_31ba7b84.webp",
  skjutglas26: "/manus-storage/26-uterum-skjutglas_840d2ae2.webp",

  // === OneDrive content: Övriga projektfoton ===
  odFoto1: "/manus-storage/1_c5762464.webp",
  odFoto2: "/manus-storage/2-2_c3f05d06.webp",
  odFoto3: "/manus-storage/5a614d2f45fe4182ac89a59ed44b24f8_dad9fb12.webp",
  odFoto4: "/manus-storage/img-72361_f8e65fc6.webp",
  odFoto5: "/manus-storage/1e09c4-1_3b2c3339.webp",
  odFoto6: "/manus-storage/1e09c4-1_3b2c3339.webp",
  odFoto7: "/manus-storage/821b6a-1_91ef60fc.webp",
  odFoto8: "/manus-storage/821b6a-1_91ef60fc.webp",
  odFoto9: "/manus-storage/4d8ab5-1_ec71e555.webp",
} as const;
